import { render, staticRenderFns } from "./SinglePatient.vue?vue&type=template&id=2e8b370a&scoped=true&"
import script from "./SinglePatient.vue?vue&type=script&lang=js&"
export * from "./SinglePatient.vue?vue&type=script&lang=js&"
import style0 from "./SinglePatient.vue?vue&type=style&index=0&id=2e8b370a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b370a",
  null
  
)

export default component.exports